import { fixedUi } from '@/i18n/fixedUi';
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import TemuPhase2OpsStubPage from '@/temu-platform/modules/ops/TemuPhase2OpsStubPage';
import { normalizeTemuShopTypeSlug } from '@/temu-platform/constants/temuRoutes';
import '@/styles/temu-platform/temu-product-ops.css';

const DIMS = [
  {
    id: 'sample',
    label: '寄样单',
    title: '寄样单',
    moduleKey: 'aftersale',
    listFnName: 'listAftersale',
    syncFnName: 'syncAftersale',
  },
  {
    id: 'quality',
    label: '质检单',
    title: '质检单',
    moduleKey: 'quality',
    listFnName: 'listQualityInspections',
    syncFnName: 'syncQualityInspections',
  },
  {
    id: 'returns',
    label: '退供单',
    title: '退供单',
    moduleKey: 'returnOrders',
    listFnName: 'listReturnOrders',
    syncFnName: 'syncReturnOrders',
  },
];

/**
 * 全托合规 · 寄样质检：寄样 / 质检 / 退供三维切换。
 */
export default function TemuSampleQcPage() {
  const { shopType } = useParams();
  const track = normalizeTemuShopTypeSlug(shopType) || 'full';
  const [dim, setDim] = useState('sample');
  const active = useMemo(() => DIMS.find((d) => d.id === dim) || DIMS[0], [dim]);

  return (
    <div className="tpo-dim-page">
      <div className="tpo-status-tabs tpo-dim-tabs" role="tablist" aria-label={fixedUi("寄样质检维度")}>
        {DIMS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={dim === tab.id}
            className={`tpo-status-tab${dim === tab.id ? ' tpo-status-tab--active' : ''}`}
            onClick={() => setDim(tab.id)}
          >
            {fixedUi(tab.label)}
          </button>
        ))}
      </div>
      <div className="tpo-dim-page__panel">
        <TemuPhase2OpsStubPage
          key={active.id}
          track={track}
          title={active.title}
          moduleKey={active.moduleKey}
          listFnName={active.listFnName}
          syncFnName={active.syncFnName}
        />
      </div>
    </div>
  );
}
